export default __webpack_public_path__ + "static/media/Motion.9837ca83.svg";